import { shellProjectsAPI } from "@/views/ShellProjects/api";

export const getAllProjects = async (params) => {
  try {
    const res = await shellProjectsAPI.getList(params);
    return res?.data;
  } catch (e) {}
};
export const updateProject = async (body, params) => {
  try {
    const res = await shellProjectsAPI.updateShellProject(body, params);
    return res?.data;
  } catch (e) {}
};
export const getProjectInfo = async (project_id) => {
  try {
    const res = await shellProjectsAPI.getProjectInfo(project_id);
    return res;
  } catch (e) {}
};
export const updProjectInfo = async (body) => {
  try {
    const res = await shellProjectsAPI.updProjectInfo(body);
    return res;
  } catch (e) {}
};
export const getProjectTypes = async () => {
  try {
    const res = await shellProjectsAPI.getProjectTypes();
    return res?.data;
  } catch (e) {}
};
export const getEmployeeList = async () => {
  try {
    const res = await shellProjectsAPI.getEmployeeList();
    return res?.data;
  } catch (e) {}
};

export const getEntrancesBlockInfo = async (project_id) => {
  try {
    const res = await shellProjectsAPI.getEntrancesBlockInfo(project_id);
    return res?.data;
  } catch (e) {}
};
export const updEntrancesBlockInfo = async (body) => {
  try {
    const res = await shellProjectsAPI.updEntrancesBlockInfo(body);
    return res?.data;
  } catch (e) {}
};
export const getContractorsList = async () => {
  try {
    const res = await shellProjectsAPI.getContractors();
    return res?.contractors;
  } catch (e) {}
};

export const getEmployeesListByContractorId = async (contractor_id) => {
  try {
    const res = await shellProjectsAPI.getEmployeesListByContractorId(
      contractor_id
    );
    return res?.data;
  } catch (e) {}
};
export const updateShellProjectPerfomancer = async (body) => {
  try {
    const res = await shellProjectsAPI.updateShellProjectPerfomancer(body);
    return res?.data;
  } catch (e) {}
};

export const getPerformersByProjectId = async (project_id) => {
  try {
    const res = await shellProjectsAPI.getPerformersByProjectId(project_id);
    return res?.data;
  } catch (e) {}
};

export const getAssignTypes = async () => {
  try {
    const res = await shellProjectsAPI.getAssignTypes();
    return res?.data;
  } catch (e) {}
};

export const changeProjectStatus = async (project_id, params) => {
  try {
    const res = await shellProjectsAPI.changeProjectStatus(project_id, params);
    return res?.data;
  } catch (e) {}
};

export const changeProjectEntrances = async (body, params) => {
  try {
    const res = await shellProjectsAPI.changeProjectEntrances(body, params);
    return res?.data;
  } catch (e) {}
};
export const fillEntranceFlats = async (project_id, params) => {
  try {
    const res = await shellProjectsAPI.fillEntranceFlats(project_id, params);
    return res?.data;
  } catch (e) {}
};

export const deleteShellProjectPerfomancer = async (body) => {
  const res = await shellProjectsAPI.deleteShellProjectPerfomancer(body);
  return res?.data;
};

export const copyPasteEntranceProperties = async (body, params) => {
  const res = await shellProjectsAPI.copyPasteEntranceProperties(body, params);
  return res?.data;
};

export const transferEntranceProject = async (body, params) => {
  try {
    const res = await shellProjectsAPI.transferProject(body, params);
    return res?.data;
  } catch (e) {}
};

export const getProjectsById = async (project_id) => {
  try {
    const res = await shellProjectsAPI.getProjectsById(project_id);
    return res?.data;
  } catch (e) {}
};

export const generateDoc = async (body) => {
  try {
    const res = await shellProjectsAPI.generateDoc(body);
    return res?.data;
  } catch (e) {}
};

export const downloadDoc = async (body) => {
  try {
    const res = await shellProjectsAPI.downloadDoc(body);
    return res?.data;
  } catch (e) {}
};

export const deleteDoc = async (project_agreement_id) => {
  try {
    const res = await shellProjectsAPI.deleteDoc(project_agreement_id);
    return res?.data;
  } catch (e) {}
};

export const putSBSProject = async (body) => {
  try {
    const res = await shellProjectsAPI.putSBSProject(body);
    return res?.data;
  } catch (e) {}
};

export const getProjectEntrances = async (project_id) => {
  try {
    const res = await shellProjectsAPI.getProjectEntrances(project_id);
    return res?.data;
  } catch (e) {}
};

export const getProjectMaterials = async (project_id) => {
  try {
    const res = await shellProjectsAPI.getProjectMaterials(project_id);
    return res?.data;
  } catch (e) {}
};

export const recalcProjectSmeta = async (project_id) => {
  try {
    await shellProjectsAPI.recalcProjectSmeta(project_id);
    return true;
  } catch (e) {}
};

export const replaceWorksetMaterials = async (body) => {
  try {
    const res = await shellProjectsAPI.replaceWorksetMaterials(body);
    return res?.data;
  } catch (e) {}
};

export const projectsColumns = [
  {
    name: "project_id",
    field: "project_id",
    label: "ID",
    align: "center",
  },
  {
    name: "project_short_name",
    field: "project_short_name",
    label: "Наименование",
    align: "left",
  },
  {
    name: "project_type_id",
    field: "project_type_name",
    label: "Тип",
    align: "left",
    headerStyle: "width: 120px",
    style: "width: 120px",
  },
  {
    name: "resident_name",
    field: "resident_name",
    label: "ЖК",
    align: "left",
    headerStyle: "width: 200px",
    style: "width: 200px",
  },
  {
    name: "entrances",
    field: "entrances",
    label: "Подъезды",
    align: "center",
    headerStyle: "width: 100px",
    style: "width: 100px",
  },
  {
    name: "entrance",
    label: "",
    align: "center",
  },
  {
    name: "project_status_name",
    field: "project_status_name",
    label: "Статус",
    align: "center",
  },
  {
    name: "avans",
    field: "avans",
    label: "Сумма аванса",
    align: "right",
    headerStyle: "width: 150px",
    style: "width: 150px",
  },
  {
    name: "start_date",
    field: "start_date",
    label: "Дата начала",
    align: "right",
    headerStyle: "width: 150px",
    style: "width: 150px",
  },
  {
    name: "finish_date",
    field: "finish_date",
    label: "Дата окончания",
    align: "right",
    headerStyle: "width: 150px",
    style: "width: 150px",
  },
  {
    name: "doc_info",
    field: "doc_info",
    label: "Договора",
    align: "left",
    headerStyle: "width: 200px",
    style: "width: 200px",
  },
  {
    name: "actions",
    field: "docactionsument",
    label: "Действие",
    align: "center",
  },
];
export const entrancesColumns = [
  {
    name: "project_entrance_id",
    field: "project_entrance_id",
    label: "ID",
    align: "center",
  },
  {
    name: "entrance",
    field: "entrance",
    label: "Подъезд №",
    align: "center",
  },
  {
    name: "block_name",
    field: "block_name",
    label: "Блок",
    align: "center",
  },
];

export const performersColumns = [
  {
    name: "employee_fio",
    field: "employee_fio",
    label: "Исполнитель",
    align: "left",
  },
  {
    name: "assign_type_name",
    field: "assign_type_name",
    label: "Позиция",
    align: "left",
  },
  {
    name: "contractor_name",
    field: "contractor_name",
    label: "Компания",
    align: "left",
  },
  {
    name: "edit",
    field: "edit",
    label: "",
    align: "center",
  },
];
